import { createAsyncAction, createAction } from 'typesafe-actions';
import { IdType } from '@rootTypes/common';
import { Filters } from '@rootTypes/filter';
import { RecoveryBinPatientsRequest, RecoveryBinPatientsResponse } from '@rootTypes/recovery-bin';

export const fetchDeletedPatients = createAsyncAction(
  'FETCH_DELETED_PATIENTS_REQUEST',
  'FETCH_DELETED_PATIENTS_SUCCESS',
  'FETCH_DELETED_PATIENTS_FAILURE',
)<RecoveryBinPatientsRequest, RecoveryBinPatientsResponse, Error>();

export const permanentlyDeletePatients = createAsyncAction(
  'PERMANENTLY_DELETE_PATIENTS_REQUEST',
  'PERMANENTLY_DELETE_PATIENTS_SUCCESS',
  'PERMANENTLY_DELETE_PATIENTS_FAILURE',
)<IdType[], IdType[], Error>();

export const recoverDeletedPatients = createAsyncAction(
  'RECOVER_DELETED_PATIENTS_REQUEST',
  'RECOVER_DELETED_PATIENTS_SUCCESS',
  'RECOVER_DELETED_PATIENTS_FAILURE',
)<IdType[], IdType[], Error>();

export const setDeletedPatientsFilter = createAction('SET_DELETED_PATIENTS_FILTER')<Filters>();
